/**
 * Created by Abner Sui on 04/29/2019.
 * Description:
 *
 * ------ maintenance history ------
 * 8/30/2021 Simon Zhao add two options for dashboard export.
 * Updated by Daniel Wang, Add option to change layout mode (Landscape/Portrait)
 */

import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription, of, Subject, forkJoin, Observable } from 'rxjs';
import { TabOptions, TabItem } from '../../widgets/tabs/tabs.model';
import { EmailDigestDialogActions, EmailDigestDialogEvents, SchedulerWeeklyOnSelectMode } from './email-digest.model';
import { EmailDigest, Frequency, TimeZone, EmailDigestType, PrintPageSize, ExportOptions, PrintLayout, Layout } from '../../tamalelibs/models/emaildigest.model';
import { AppState } from '../../redux';
import { DualListItem } from '../../widgets/dual-list/dual-list.component';
import { createSelector, select, Store } from '@ngrx/store';
import { filter, take, catchError, debounceTime, map, switchMap } from 'rxjs/operators';
import { DualListConfig, DualListEventType } from '../../widgets/dual-list/dual-list.config';
import { StoreQuerierService } from '../../services/store-querier.service';
import { EmailDigestService } from '../../services/email-digest.service';
import { BriefObject } from '../../tamalelibs/models/brief-object';
import * as lodash from 'lodash';
import { ScheduleHelperService } from '../../services/schedule-helper.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { UtilsService } from '../../tamalelibs/services/utils.service';
import { DateHelperWebService } from '../../tamalelibs/services/date-helper.web.service';
import { EntityService } from '../../tamalelibs/services/entity.service';
import { EntityBrief } from '../../tamalelibs/models/entity-brief.model';
import { EmailDigestServiceCommon } from './email-digest-common.service';
import { visibleScreensSelector } from '../../redux/reducers/system.reducer';
import { businessConstants } from '../../constants/business.constants';
import { EmailDigestActionTypes } from '../../redux/actions/email-digest.actions';
import { TamDashboardTileType } from '../tam-dashboard/tam-dashboard.model';
import { TileService } from './../../tamalelibs/services/tile.service';
import { ScreenService } from './../../tamalelibs/services/screen.service';
import { dialogConstants } from './email-digest-dialog.constants';
import { AppConfig } from '../../tamalelibs/models/app-config.model';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { ArrayHelperService } from '../../tamalelibs/services/array-helper.service';

@Component({
    selector: 'email-digest-dialog',
    templateUrl: './email-digest-dialog.component.html',
    styleUrls: ['./email-digest-dialog.component.scss']
})
export class EmailDigestDialogComponent implements OnInit, OnDestroy {

    @ViewChild('dualList', { static: false })
    dualListInst;
    @ViewChild('finder', { static: false }) finderFocusEle: any;

    opened: boolean;
    emailDigest: EmailDigest;
    tabsOptions: TabOptions;
    currentTab = 0;
    dualListConfig: DualListConfig;
    timesteps: any = { hour: 1, minute: 30, second: 60 };
    minTime: Date;
    maxTime: Date;
    time: Date;
    timezoneList: Array<TimeZone>;
    selectedTimezone: TimeZone;
    frequencyList: Array<BriefObject> = dialogConstants.frequencyList;
    selectedFrequency: BriefObject;
    everyList: Array<BriefObject>;
    selectedEvery: BriefObject;
    onWeeklyList: Array<any> = dialogConstants.onWeeklyList;
    onMonthlyList1: Array<BriefObject> = dialogConstants.onMonthlyList1;
    onMonthlyList2: Array<BriefObject>;
    selectedOnMonthly1: BriefObject;
    selectedOnMonthly2: BriefObject;
    frequencyUnit: string;
    startDate: Date;
    currentUser: SystemUser;
    onWeeklyMode: string = SchedulerWeeklyOnSelectMode.MULTIPLE;
    nameInvalid: boolean;
    isProgressing = false;
    isDashboardType: boolean;
    /**
     *a flag indicating whether there's any grid widget inside current dashboard.
     *
     * @type {boolean}
     * @memberof EmailDigestDialogComponent
     */
    isGridWidgetIncluded: boolean;
    focusFinderData: any;
    focusSelectedItems: EntityBrief[] = [];
    pageSizeItems: Array<string>;
    layoutItems: Array<string>;
    showFocus: boolean;
    formErrorMsg = {
        nameRequired: false,
        nameMaxLength: false,
        descriptionMaxLenght: false,
        focusRequired: false,
        dashboardRequired: false,
        nameDuplicated: false,
        noExportOptionChecked: false
    };
    dashboardItems = [];
    selectedDashboardItem: any;
    dialogTitle = '';
    needGetInfoFromServer: boolean;

    private _monthlyEvery: Array<BriefObject> = dialogConstants.monthlyEvery;
    private _weeklyEvery: Array<BriefObject> = dialogConstants.weeklyEvery;
    private _onMonthlyDayList: Array<BriefObject> = dialogConstants.onMonthlyDayList;
    private _onMonthlyXList: Array<BriefObject> = dialogConstants.onMonthlyXList;
    private _preDigest: EmailDigest;
    private _focusSource: any;
    private _dialogOpType: string;
    private _focusFilterHandler$: Subject<string> = new Subject();
    private _gridUpdateRow$ = new Subject();
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _store: Store<AppState>,
        private _storeQuerier: StoreQuerierService,
        private _emailDigestService: EmailDigestService,
        private _emailDigestServiceCommon: EmailDigestServiceCommon,
        private _toast: ToastService,
        private _alert: AlertWindowService,
        private _utils: UtilsService,
        private _entityService: EntityService,
        private _screenService: ScreenService,
        private _tileService: TileService,
    ) { }

    ngOnInit(): void {
        this._destroySubscriptions.push(
            this._emailDigestService.dialogActionSubject$.subscribe(action => this._actionHandler(action)),
            this._focusFilterHandler$.pipe(
                debounceTime(250),
                filter(filterStr => filterStr != null && filterStr.length > 0)
            ).subscribe(filterStr => this._focusFilterHandler(filterStr)),
        );
        this.currentUser = this._storeQuerier.getCurrentUser();
        this._initTimezoneList();
        this._initTabs();
        this._initDualListConfig();
    }

    ngOnDestroy(): void {
    }

    cancel() {
        if (this._utils.isEqual(this.emailDigest, this._preDigest)) {
            this._close();
            this._emailDigestService.dialogFeedbackSubject$.next({
                type: EmailDigestDialogEvents.CANCEL,
            });
        } else {
            this._alert.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?']).pipe(
                take(1),
            ).subscribe(result => {
                if (result) {
                    this._close();
                    this._emailDigestService.dialogFeedbackSubject$.next({
                        type: EmailDigestDialogEvents.CANCEL,
                    });
                }
            });
        }
    }

    onChangeEvery(value: BriefObject) {
        this.selectedEvery = value;
        this.emailDigest.scheduler.every = this.selectedEvery.id;
        if (this.selectedFrequency.id === Frequency.WEEKLY) {
            if (this.selectedEvery.id > 1) {
                const tempList = this.onWeeklyList.filter(item => item.selected);
                if (!tempList || tempList.length === 0 || tempList.length > 1) {
                    this._setDefaultWeeklyOn();
                }
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.SINGLE;
            } else {
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.MULTIPLE;
                const tempList = this.onWeeklyList.filter(item => item.selected);
                if (!tempList || tempList.length === 0) {
                    this._setDefaultWeeklyOn();
                }
            }
        }
    }

    onChangeFrequency(value: BriefObject) {
        this.selectedFrequency = value;
        this._afterChangeFrequency();
    }

    onChangeOnMonthly1(value: BriefObject) {
        this.selectedOnMonthly1 = value;
        if (this.selectedOnMonthly1.id === 'day') {
            this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyDayList);
            this.onChangeOnMonthly2(this.onMonthlyList2[0]);
        } else if (this.selectedOnMonthly1.id === 'day:L') {
            this.onMonthlyList2 = [];
            this.selectedOnMonthly2 = null;
            this.emailDigest.scheduler.on = this.selectedOnMonthly1.id;
        } else {
            this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyXList);
            this.onChangeOnMonthly2(this.onMonthlyList2[1]);
        }
    }

    onChangeOnMonthly2(value: BriefObject) {
        this.selectedOnMonthly2 = value;
        this.emailDigest.scheduler.on = this.selectedOnMonthly1.id + ':' + this.selectedOnMonthly2.id;
    }

    onChangeOnWeekly(value: boolean, index: number) {
        this.onWeeklyList[index].selected = !this.onWeeklyList[index].selected;
        let tempList = this.onWeeklyList.filter(item => item.selected);
        if (!tempList || tempList.length === 0) {
            if (this.selectedEvery.id === 1) {
                this.onWeeklyList[index].selected = !this.onWeeklyList[index].selected;
                this.onWeeklyList = lodash.cloneDeep(this.onWeeklyList); // kendo button group does not support select at least one when mode is multiple, so need to clone deep to triger refresh kendo button group data source to make sure select at least one
            } else {
                return; // Kendo button group behavior: when mode is single, one click will trigger this function twice
            }
        }
        tempList = this.onWeeklyList.filter(item => item.selected);
        this.emailDigest.scheduler.on = tempList.map(item => item.id).join(',');
    }

    onChangeStartDate(value: Date, isFromUser: boolean = true) {
        if (isFromUser) {
            const tempYear = value.getFullYear();
            const tempMonth = value.getMonth();
            const tempDayOfMonth = value.getDate();
            this.startDate = new Date(tempYear, tempMonth, tempDayOfMonth);
        }
        this.emailDigest.scheduler.startDate = this._emailDigestService.parseStartDateFromUIToServer(this.startDate, this.emailDigest.minuteOffset);
    }

    onChangeTime(value: Date) {
        const hourNum = value.getHours();
        const minuteNum = value.getMinutes();
        this.emailDigest.scheduler.time = hourNum.toString() + ':' + minuteNum.toString();
        this._initTime();
    }

    onChangeTimezone(value: TimeZone) {
        this.selectedTimezone = value;
        this.emailDigest.scheduler.configuration = this.selectedTimezone.zonename;
        this.emailDigest.minuteOffset = this.selectedTimezone.offset;
        this.emailDigest.scheduler.startDate = this._emailDigestService.parseStartDateFromUIToServer(this.startDate, this.emailDigest.minuteOffset);
    }

    onFocusEnter(event) {
        event.stopImmediatePropagation();
    }

    onFocusOpen(event) {
        if (this.focusSelectedItems.length >= 5) {
            event.preventDefault();
        }
    }

    handleFocusFilter(filterStr) {
        this.finderFocusEle.toggle(false);
        if (this.focusSelectedItems.length >= 5) {
            return;
        }
        this._focusFilterHandler$.next(filterStr);
    }

    focusValueChange() {
        this.formErrorMsg.focusRequired = false;
        if (this.focusSelectedItems.length >= 5) {
            this.finderFocusEle.toggle(false);
        }
    }

    validateExportOptions(e: any) {
        this.formErrorMsg.noExportOptionChecked = this.isDashboardType && this.emailDigest.reportData && this.emailDigest.reportData.attachment
            && !this.emailDigest.reportData.attachment.excel && !this.emailDigest.reportData.attachment.pdf;
    }

    returnDetail() {
        this.tabsOptions.isRefresh = true;
        this.currentTab = 0;
        this.tabsOptions.selectedIndex = 0;
    }

    save() {
        const name = this.emailDigest.name.trim();
        if (!name) {
            this.formErrorMsg.nameRequired = true;
            this.formErrorMsg.nameMaxLength = false;
            this.returnDetail();
        } else if (name.length > 128) {
            this.formErrorMsg.nameRequired = false;
            this.formErrorMsg.nameMaxLength = true;
            this.returnDetail();
        } else if (this.emailDigest.description && this.emailDigest.description.length > 128) {
            this.formErrorMsg.descriptionMaxLenght = true;
            this.returnDetail();
        } else if (this.isDashboardType && this.showFocus && this.focusSelectedItems.length === 0) {
            this.formErrorMsg.focusRequired = true;
            this.returnDetail();
        } else if (this.isDashboardType && (!this.selectedDashboardItem || this.selectedDashboardItem.length === 0)) {
            this.formErrorMsg.dashboardRequired = true;
            this.returnDetail();
        } else {
            this.validateExportOptions({});
            this.isProgressing = true;
            this._emailDigestService.checkEmailDigestName(name, this.emailDigest.id).pipe(
                catchError((e: any) => {
                    const mockResult = {
                        result: false,
                    };
                    this.isProgressing = false;
                    return of(mockResult);
                })
            ).subscribe(result => {
                this.isProgressing = false;
                if (!result.result) {
                    this.formErrorMsg.nameDuplicated = true;
                    this.returnDetail();
                } else {
                    this.formErrorMsg.nameDuplicated = false;
                    if (this.currentUser.credential.publishPubConfiguration) {
                        if (!this.emailDigest.recipients || this.emailDigest.recipients.length === 0) {
                            this.emailDigest.recipients = [this.currentUser.id];
                        }
                    }
                    this.emailDigest.schedulerStr = ScheduleHelperService.getScheduledAt(this.emailDigest.scheduler);
                    this.emailDigest.emailSection.forEach(item => {
                        if (item.isIncludeEvents) {
                            item.advFilter = item.advFilter.replace(AppConfig.defaultAdvFilter, AppConfig.defaultAdvFilterNoteOrEvent);
                        } else {
                            item.advFilter = item.advFilter.replace(AppConfig.defaultAdvFilterNoteOrEvent, AppConfig.defaultAdvFilter);
                        }
                    });
                    if (this.isDashboardType) {
                        this._saveDashboardEmailSettings();
                    } else {
                        this._emailDigestService.dialogFeedbackSubject$.next({
                            type: EmailDigestDialogEvents.SAVE,
                            payload: this.emailDigest,
                        });
                    }
                    this._close();
                }
            });
        }
    }

    validateName(value: string) {
        if (!value || value.length > 128) {
            this.nameInvalid = true;
        } else {
            this.nameInvalid = false;
        }
        this.formErrorMsg.nameRequired = !value;
        this.formErrorMsg.nameMaxLength = value.length > 128;
        this.formErrorMsg.nameDuplicated = false;
    }

    validateDescription(value: string) {
        this.formErrorMsg.descriptionMaxLenght = value && value.length > 128;
    }

    changeDashboard() {
        this.formErrorMsg.dashboardRequired = false;
        this.emailDigest.reportData.dashboardId = this.selectedDashboardItem.id;
        this._checkIfGridIncludedInDashboard();
        this._onDigestChanged(true);
        this.focusSelectedItems = [];
        this.emailDigest.reportData.focus = [];
        this._getDashboardFocusSorce();
    }

    private _actionHandler(action) {
        if (action.type === EmailDigestDialogActions.OPEN ||
            action.type === EmailDigestDialogActions.EDIT ||
            action.type === EmailDigestDialogActions.COPY) {
            this._preDigest = lodash.cloneDeep(action.payload);
            this.emailDigest = lodash.cloneDeep(this._preDigest);
            this._onDigestChanged();
            if (action.isGridWidgetIncluded !== undefined) {
                this.isGridWidgetIncluded = action.isGridWidgetIncluded;
            } else {
                this._checkIfGridIncludedInDashboard();
            }
            this._initData();
            this.isDashboardType = action.payload.type === EmailDigestType.DASHBOARD;
            if (this.isDashboardType) {
                this._initDashboardInfo(action);
            } else {
                this.dialogTitle = 'Detail Settings';
            }
            if (action.type === EmailDigestDialogActions.EDIT ||
                action.type === EmailDigestDialogActions.COPY) {
                this.validateName(this.emailDigest.name.trim());
            } else {
                this.nameInvalid = false;
            }

            this.opened = !this.opened;
        }
    }

    private _initDashboardInfo(action) {
        this.pageSizeItems = PrintPageSize;
        this.layoutItems = PrintLayout;
        this._dialogOpType = action.type;
        if (action.type === EmailDigestDialogActions.OPEN) {
            this.dialogTitle = 'New Schedule Report';
        } else if (action.type === EmailDigestDialogActions.EDIT) {
            this.dialogTitle = 'Edit Schedule Report';
        } else if (action.type === EmailDigestDialogActions.COPY) {
            this.dialogTitle = 'New Schedule Report';
        }
        this._store.pipe(
            select(visibleScreensSelector),
            filter(item => !!item),
            take(1),
        ).subscribe(items => {
            const tempData = items.filter(data => data.type === businessConstants.screenType.dashboard);
            ArrayHelperService.sort(tempData, 'name');
            this.dashboardItems = tempData;
        });
        // if the dialog open from dashboard page, needGetInfoFromServer=false, only open from email page, needGetInfoFromServer=true
        // only open from dashboard page, dashboard dropdown is disabled=true
        this.needGetInfoFromServer = !!action.needGetInfoFromServer;
        if (action.needGetInfoFromServer) {
            if (action.type === EmailDigestDialogActions.OPEN) {
                this.showFocus = false;
                this._focusSource = null;
                this.selectedDashboardItem = null;
            } else {
                this._getDashboardFocusSorce();
            }
        } else {
            this.showFocus = !!action.showFocus;
            this._focusSource = action.focusSource;
            // selected dashboard maybe not in the dashboardItems, might hidden
            this.selectedDashboardItem = {
                id: this.emailDigest.reportData.dashboardId,
                name: action.dashboardName
            };
            if (this.showFocus) {
                this._formatSelectEntityByIds();
            } else {
                // if dashboard change focus type(enabled->all/current/specific), clear emaildigest save focus value
                this.focusSelectedItems = [];
            }
        }
        this._gridUpdateRow$ = action.gridUpdateRow$;
    }

    private _afterChangeFrequency() {
        this.emailDigest.scheduler.frequency = this.selectedFrequency.id;
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            this.everyList = this._monthlyEvery;
            this.onChangeEvery(this.everyList[0]);
            this.onChangeOnMonthly1(this.onMonthlyList1[2]);
            this.frequencyUnit = 'month(s)';
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.everyList = this._weeklyEvery;
            this.onChangeEvery(this.everyList[0]);
            this._setDefaultWeeklyOn();
            this.frequencyUnit = 'week(s)';
        } else {
            this.everyList = [];
            this.selectedEvery = null;
            this.emailDigest.scheduler.every = 1;
            this.frequencyUnit = null;
            delete this.emailDigest.scheduler.on;
        }
    }

    private _checkIfGridIncludedInDashboard() {
        if (this.emailDigest.type === EmailDigestType.DASHBOARD && this.emailDigest.reportData && this.emailDigest.reportData.dashboardId) {
            this._screenService.getById(this.emailDigest.reportData.dashboardId).pipe(
                take(1),
                switchMap((screen: any) => {
                    screen.configuration.widgets = screen.configuration.widgets.filter(item => item.tileId);
                    if (screen.configuration.widgets && screen.configuration.widgets.length > 0) {
                        const observables = [];
                        screen.configuration.widgets.forEach(element => {
                            observables.push(this._tileService.getById(element.tileId));
                        });
                        return forkJoin(observables);
                    } else {
                        return Observable.of([]);
                    }
                }),
                catchError((e: any) => {
                    return of(null);
                })
            ).subscribe((tiles: Array<any>) => {
                this.isGridWidgetIncluded = tiles && tiles.length > 0 && tiles.findIndex(tile => tile.visualization.type === TamDashboardTileType.GRID) >= 0;
            });
        }
    }

    private _close() {
        this.isGridWidgetIncluded = false;
        this.opened = false;
    }

    private _focusFilterHandler(filterStr: string) {
        this.finderFocusEle.loading = true;
        this._entityService.getEntityListBySearchTextQuick(1, 10, filterStr, this._focusSource).pipe(
            map(response => this._entityService.mapEntityBriefList(response)),
            take(1),
        ).subscribe(data => {
            this.finderFocusEle.toggle(true);
            this.finderFocusEle.loading = false;
            this.focusFinderData = data;
        });
    }

    private _getDashboardFocusSorce() {
        const dashboardId = this.emailDigest.reportData.dashboardId;
        this._emailDigestServiceCommon.getDashboardFocusSorce(dashboardId).subscribe((data) => {
            this.showFocus = data['showFocus'];
            this._focusSource = data['focusSource'];
            // selected dashboard maybe not in the dashboardItems, might hidden
            if (data['name']) {
                this.selectedDashboardItem = {
                    id: this.emailDigest.reportData.dashboardId,
                    name: data['name']
                };
            } else {
                this.selectedDashboardItem = null;
            }
            if (this.showFocus) {
                this._formatSelectEntityByIds();
            } else {
                // if dashboard change focus type(enabled->all/current/specific), clear emaildigest save focus value
                this.focusSelectedItems = [];
            }
        });
    }

    private _initData() {
        this._initDualListData();
        this.minTime = DateHelperWebService.getDateOnlyOfToday();
        this.maxTime = new Date(this.minTime.getFullYear(), this.minTime.getMonth(), this.minTime.getDate() + 1);
        this.currentTab = 0;
        this.tabsOptions.selectedIndex = 0;
        this.showFocus = false;
        this._focusSource = null;
        this.dashboardItems = [];
        this.selectedDashboardItem = null;
        this.dialogTitle = '';
        this.needGetInfoFromServer = false;
        this.formErrorMsg.nameRequired = false;
        this.formErrorMsg.nameMaxLength = false;
        this.formErrorMsg.nameDuplicated = false;
        this.formErrorMsg.descriptionMaxLenght = false;
        this.formErrorMsg.focusRequired = false;
        this.formErrorMsg.dashboardRequired = false;
        this.formErrorMsg.noExportOptionChecked = false;
        this._initTime();
        this._initTimezone();
        this._initStartDate();
        this._initFrequency();
        this._initOn();
        this._initEvery();
    }

    private _initDualListConfig() {
        this.dualListConfig = new DualListConfig();
        this.dualListConfig.titles = ['Users/Teams who will not receive emails', 'Users/Teams who will receive emails'];
        this.dualListConfig.placeholderText = 'Search User or Teams';
        this.dualListConfig.dataTextField = 'name';
        this.dualListConfig.dataValueField = 'id';
        this.dualListConfig.dataSource = [];
        this._destroySubscriptions.push(
            this.dualListConfig.feedbackSubject$.subscribe(data => this._onChangeRecipients(data)),
        );
    }

    private _initDualListData() {
        if (this.currentUser.credential.publishPubConfiguration) {
            const accessListSelector = createSelector(
                (state: AppState) => state.users,
                (state: AppState) => state.teams,
                (allUser, allTeam) => {
                    if (allUser.length === 0 && allTeam.length === 0) {
                        return [];
                    }
                    const users = allUser.map(item => {
                        if (this.emailDigest.recipients && this.emailDigest.recipients.includes(item.id)) {
                            return new DualListItem(item, 'right');
                        } else {
                            return new DualListItem(item);
                        }
                    });
                    const teams = allTeam.map(item => {
                        if (this.emailDigest.recipients && this.emailDigest.recipients.includes(item.id)) {
                            return new DualListItem(Object.assign({ type: 'team' }, item), 'right');
                        } else {
                            return new DualListItem(Object.assign({ type: 'team' }, item));
                        }
                    });
                    return users.concat(teams);
                }
            );
            this._store.pipe(
                select(accessListSelector),
                filter((list: any) => list.length > 0),
                take(1),
            ).subscribe(list => {
                this.dualListConfig.dataSource = list;
            });
        } else {
            delete this.emailDigest.recipients;
        }
    }

    private _initEvery() {
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            this.everyList = this._monthlyEvery;
            this.selectedEvery = this.everyList.find(item => item.id === this.emailDigest.scheduler.every);
            this.onChangeEvery(this.selectedEvery);
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.everyList = this._weeklyEvery;
            this.selectedEvery = this.everyList.find(item => item.id === this.emailDigest.scheduler.every);
            this.onChangeEvery(this.selectedEvery);
            if (this.selectedEvery.id > 1) {
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.SINGLE;
            } else {
                this.onWeeklyMode = SchedulerWeeklyOnSelectMode.MULTIPLE;
            }
        } else {
            this.everyList = [];
            this.selectedEvery = null;
            this.emailDigest.scheduler.every = 1;
        }
    }

    private _initFrequency() {
        this.selectedFrequency = this.frequencyList.find(item => item.id === this.emailDigest.scheduler.frequency);
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            this.frequencyUnit = 'month(s)';
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.frequencyUnit = 'week(s)';
        } else {
            this.frequencyUnit = null;
        }
    }

    private _initOn() {
        if (this.selectedFrequency.id === Frequency.MONTHLY) {
            let on1Id, on2Id;
            if (this.emailDigest.scheduler.on === 'day:L') {
                on1Id = this.emailDigest.scheduler.on;
            } else {
                const tempIndex = this.emailDigest.scheduler.on.indexOf(':');
                on1Id = this.emailDigest.scheduler.on.substring(0, tempIndex);
                on2Id = this.emailDigest.scheduler.on.substring(tempIndex + 1);
            }
            this.selectedOnMonthly1 = this.onMonthlyList1.find(item => item.id === on1Id);
            if (this.selectedOnMonthly1.id === 'day') {
                this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyDayList);
                this.onChangeOnMonthly2(this.onMonthlyList2.find(item => item.id === on2Id));
            } else if (this.selectedOnMonthly1.id === 'day:L') {
                this.onMonthlyList2 = [];
                this.selectedOnMonthly2 = null;
            } else {
                this.onMonthlyList2 = lodash.cloneDeep(this._onMonthlyXList);
                let tempOnMonthly2 = this.onMonthlyList2.find(item => item.id === on2Id);
                if (!tempOnMonthly2) {
                    tempOnMonthly2 = this.onMonthlyList2[1];
                }
                this.onChangeOnMonthly2(tempOnMonthly2);
            }
        } else if (this.selectedFrequency.id === Frequency.WEEKLY) {
            this.onWeeklyList.forEach(item => {
                if (this.emailDigest.scheduler.on.includes(item.id)) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
            });
        } else {
            this.everyList = [];
            this.selectedEvery = null;
            this.emailDigest.scheduler.every = 1;
        }
    }

    private _initStartDate() {
        this.startDate = this._emailDigestService.parseStartDateFromServerToUI(this.emailDigest.scheduler.startDate, this.emailDigest.minuteOffset);
        this.onChangeStartDate(this.startDate, false); // Handle 1.0 bug, start date is not converted to time in target time zone. Here will always try to convert start date.
    }

    private _initTabs() {
        const menuItems = [
            new TabItem('Details'),
            new TabItem('Recipients'),
        ];
        this.tabsOptions = new TabOptions(menuItems, 0, false);
        this._destroySubscriptions.push(
            this.tabsOptions.events$.subscribe(event => {
                if (event.type === 'TAB_CHANGED') {
                    this.currentTab = event.payload;
                }
            }),
        );
    }

    private _initTime() {
        const timeStr = this.emailDigest.scheduler.time;
        const tempIndex = timeStr.indexOf(':');
        const hourStr = timeStr.substring(0, tempIndex);
        const minuteStr = timeStr.substring(tempIndex + 1);
        this.time = new Date(this.minTime.getFullYear(), this.minTime.getMonth(), this.minTime.getDate(), +hourStr, +minuteStr, 0);
    }

    private _initTimezone() {
        const emailDigest = this._emailDigestService.deleteConfigurationTimezone(lodash.cloneDeep(this.emailDigest));
        this.selectedTimezone = this.timezoneList.find(item => item.id.includes(emailDigest.scheduler.configuration));
    }

    private _initTimezoneList() {
        this.timezoneList = this._emailDigestService.timezoneList;
    }

    private _onChangeRecipients(event) {
        if (event.type === DualListEventType.selectChange) {
            this.emailDigest.recipients = this.dualListInst.getSelectedItem(true);
        }
    }

    private _onDigestChanged(isReset: boolean = false) {
        if (isReset || (this.emailDigest && this.emailDigest.reportData && !this.emailDigest.reportData.attachment)) {
            this.emailDigest.reportData.attachment = new ExportOptions();
        }

        this.isGridWidgetIncluded = false;
    }

    private _setDefaultWeeklyOn() {
        this.onWeeklyList.forEach(item => item.selected = false);
        this.onChangeOnWeekly(true, 1);
    }

    private _saveDashboardEmailSettings() {
        const reportData = {
            displaySetting: this.emailDigest.reportData.displaySetting,
            dashboardId: this.emailDigest.reportData.dashboardId,
            focus: this.focusSelectedItems.map(item => item.id),
            configuration: this.emailDigest.reportData.configuration,
            attachment: this.emailDigest.reportData.attachment
        };
        if (reportData.displaySetting) {
            if (reportData.displaySetting[StringLiteralsPipe.translate('general.layout')] === Layout.LANDSCAPE) {
                reportData.displaySetting[StringLiteralsPipe.translate('general.landscape')] = true;
            } else {
                reportData.displaySetting[StringLiteralsPipe.translate('general.landscape')] = false;
            }
            // remove useless property layout
            delete reportData.displaySetting[StringLiteralsPipe.translate('general.layout')];
        }
        const scheduler = this._emailDigestService.parseSchedulerToParams(this.emailDigest.scheduler);
        const data = {
            id: this.emailDigest.id,
            name: this.emailDigest.name.trim(),
            description: this.emailDigest.description,
            minuteOffset: this.emailDigest.minuteOffset,
            type: this.emailDigest.type,
            reportData: reportData,
            scheduler: scheduler,
            recipients: this.emailDigest.recipients,
            active: this.emailDigest.active
        };
        if (this._dialogOpType === EmailDigestDialogActions.EDIT) {
            // edit email
            this._emailDigestServiceCommon.updateEmailDigest(data).subscribe((result) => {
                if (result) {
                    this._store.dispatch({
                        type: EmailDigestActionTypes.UPDATE_CONFIG,
                        payload: EmailDigest.parse(result),
                    });
                    this._toast.notify({
                        style: NotificationStyles.Success,
                        message: 'The email digest with name ' + data.name + ' successfully updated.',
                    });
                    const tempData = this._emailDigestService.parseEmailDigestFromResponse([result]);
                    tempData[0]['schedulerStr'] = ScheduleHelperService.getScheduledAt(result.scheduler);
                    if (this._gridUpdateRow$) {
                        this._gridUpdateRow$.next({
                            type: 'UPDATE_GRID_ROW',
                            payload: tempData[0]
                        });
                    }
                }
            });
        } else {
            // create/copy email
            this._emailDigestServiceCommon.saveEmailDigest(data).subscribe(result => {
                if (result) {
                    this._store.dispatch({
                        type: EmailDigestActionTypes.ADD_CONFIG,
                        payload: EmailDigest.parse(result),
                    });
                    this._toast.notify({
                        style: NotificationStyles.Success,
                        message: 'The email digest with name ' + data.name + ' successfully saved.',
                    });
                    const tempData = this._emailDigestService.parseEmailDigestFromResponse([result]);
                    tempData[0]['schedulerStr'] = ScheduleHelperService.getScheduledAt(result.scheduler);
                    if (this._gridUpdateRow$) {
                        this._gridUpdateRow$.next({
                            type: 'ADD_GRID_ROW',
                            payload: tempData
                        });
                    }
                }
            });
        }
    }

    private _formatSelectEntityByIds() {
        const entityIds = this.emailDigest.reportData.focus;
        if (entityIds && entityIds.length > 0) {
            this._entityService.getEntityListByIdsQuick(entityIds).pipe(
                map(response => this._entityService.mapEntityBriefList(response)),
            ).subscribe((items => {
                this.focusSelectedItems = items;
            }));
        } else {
            this.focusSelectedItems = [];
        }
    }
}
